module.exports = __webpack_public_path__ + "static/media/bg_minecraft-sun0.bfe84d4b.png";